var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c('a-tabs',{on:{"change":_vm.changeTab}},[_c('a-tab-pane',{key:"1",attrs:{"tab":_vm.$t('数据列表')}},[_c('inspectionResults',{ref:"dataList"})],1),_c('a-tab-pane',{key:"2",attrs:{"tab":_vm.$t('地图展示')}},[_c('MapList',{ref:"mapList"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }